"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconNotAllowed = void 0;
var React = __importStar(require("react"));
var IconNotAllowed = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M11.996,4.6528 C16.047,4.6528 19.344,7.9498 19.344,12.0008 C19.344,13.4538 18.926,14.8408 18.129,16.0398 L7.957,5.8678 C9.156,5.0708 10.543,4.6528 11.996,4.6528 M11.996,19.3518 C7.945,19.3518 4.648,16.0548 4.648,12.0048 C4.648,10.5508 5.066,9.1608 5.863,7.9618 L16.043,18.1408 C14.844,18.9298 13.453,19.3518 11.996,19.3518 M19.07,4.9298 C17.183,3.0398 14.672,2.0008 12,2.0008 C9.699,2.0008 7.539,2.7548 5.758,4.1838 C5.465,4.4188 5.187,4.6688 4.926,4.9258 C4.668,5.1838 4.418,5.4618 4.187,5.7508 C2.754,7.5358 2,9.6958 2,11.9968 C2,14.6688 3.039,17.1798 4.93,19.0668 C6.82,20.9578 9.328,21.9968 12,21.9968 C14.301,21.9968 16.461,21.2388 18.246,19.8088 C18.535,19.5788 18.812,19.3288 19.07,19.0708 C19.332,18.8088 19.582,18.5318 19.812,18.2388 C21.246,16.4618 22,14.3008 22,12.0008 C22,9.3288 20.961,6.8168 19.07,4.9298" }))); };
exports.IconNotAllowed = IconNotAllowed;
exports.IconNotAllowed.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconNotAllowed;
